module.exports = __webpack_public_path__ + "bd09391da3c528d955b1dc3248b3104f.MP3";